export default __webpack_public_path__ + "static/media/Graveler.5b3a6797.png";